import React from 'react';
import Icon from '../../../components/AppIcon';


const TrustSignalsSection = () => {
  const stats = [
  {
    id: 1,
    icon: 'Users',
    value: '18,700+',
    label: 'Aussie Buyers Helped',
    color: 'primary'
  },
  {
    id: 2,
    icon: 'FileSearch',
    value: '62,000+',
    label: 'Properties Analysed',
    color: 'accent'
  },
  {
    id: 3,
    icon: 'DollarSign',
    value: '$240M+',
    label: 'Savings Identified (AUD)',
    color: 'success'
  },
  {
    id: 4,
    icon: 'Star',
    value: '4.9/5',
    label: 'Average Rating',
    color: 'warning'
  }];


  return (
    <section className="py-12 md:py-20 lg:py-28 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-success/10 rounded-full text-success text-sm md:text-base font-medium mb-4">
            <Icon name="Shield" size={16} color="var(--color-success)" />
            <span>Trusted by Smart Property Buyers</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-foreground mb-4 md:mb-6">
            Join Thousands of Smart Property Buyers
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-muted-foreground max-w-3xl mx-auto">
            ListingLens is trusted by property buyers across Australia and the UAE
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 lg:gap-8 mb-12 md:mb-16 lg:mb-20">
          {stats?.map((stat) =>
          <div key={stat?.id} className="bg-card rounded-xl border border-border p-4 md:p-6 text-center shadow-elevation-sm hover:shadow-elevation-md transition-all duration-300">
              <div className={`w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-full bg-${stat?.color}/10 flex items-center justify-center mx-auto mb-3 md:mb-4`}>
                <Icon name={stat?.icon} size={window.innerWidth >= 1024 ? 28 : window.innerWidth >= 768 ? 24 : 20} color={`var(--color-${stat?.color})`} />
              </div>
              <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-1 md:mb-2 text-data">{stat?.value}</p>
              <p className="text-xs md:text-sm text-muted-foreground">{stat?.label}</p>
            </div>
          )}
        </div>

      </div>
    </section>);

};

export default TrustSignalsSection;